// utils/accessibility.ts
export const removeDisabledElementsFromTabIndex = (): void => {
  // First, update elements that are explicitly disabled or aria-disabled.
  const disabledElements = document.querySelectorAll(
    '[disabled]:not([data-allow-disabled-focus="true"]), ' +
    '[aria-disabled="true"]:not([data-allow-disabled-focus="true"])'
  );
  disabledElements.forEach((element) => {
    (element as HTMLElement).setAttribute('tabindex', '-1');
  });

  // Then, for any element that is a descendant of an element with the class 'disablePropertyForCommonFields'
  const commonDisabledChildren = document.querySelectorAll('.disablePropertyForCommonFields *');
  commonDisabledChildren.forEach((element) => {
    (element as HTMLElement).setAttribute('tabindex', '-1');
  });
};
